export const environment = {
  production: false,
  apiUrl: 'https://lmsapi.banqmart.com',
  partnerBaseUrl: 'https://qappapi.finqy.ai/api/v1',
  authUrl: 'https://api-auth.finqy.ai/oauth/getAccesstoken',
};